<template>
  <div>
    <input 
        id="GooglePlaces"
        class="form-control"
        ref="collectionPlaceAutocomplete"
        type="search"
        placeholder="Enter your postcode, town or city"
      />

    <branch-finder-modal v-if="location" :location="location" v-on:close="reset()" />
  </div>
</template>

<script>
import axios from 'axios'

import { GEOCODING_URL, GEOCODING_KEY } from '@vue/common/constants/config'
import { setOptions, importLibrary } from '@googlemaps/js-api-loader'

import BranchFinderModal from './components/branch-finder-modal'

setOptions({ key: window.siteSettings.googleMapsApiKey }); 

export default {
  name: 'BranchFinder',
  components: {
    BranchFinderModal
  },
  data() {
    return {
      location: null,
    }
  },
  mounted: async  function()  {
    const autocompleteOptions = {
        componentRestrictions: { country: window.siteSettings.countryCode || 'gb' },
        fields: ['address_components', 'geometry'],
        types: ['geocode']
      };

      let  places  = await importLibrary("places");
      
      const autocomplete = new places.Autocomplete(document.getElementById("GooglePlaces"), autocompleteOptions);
      
      autocomplete.addListener('place_changed', () => this.onPlaceSelected(autocomplete.getPlace()));   
  },
  methods: {
    reset(){
      this.branches = []
      this.location = null;
    },
    async onPlaceSelected(place) {

      let coords = {};
        if(place) {
          if(place.geometry) {
            // If Google Places returns lat and lng use these
            this.location = {
              latitude: place.geometry.location?.lat(),
              longitude: place.geometry.location?.lng()
            }
          } else {
            this.fallbackLookup(place)
          }
        }
    },
    fallbackLookup(place) {
      const params = {
          Key: encodeURIComponent(GEOCODING_KEY),
          Country: encodeURIComponent('GBR'),
          Location: encodeURIComponent(
            `${place.route}, ${place.locality}, ${place.administrative_area_level_1}, ${place.administrative_area_level_2}`
          )
        }

        const queryString = Object.keys(params)
          .map(key => key + '=' + params[key])
          .join('&')

        const url = `${GEOCODING_URL}?${queryString}`

        axios
          .post(url, null, { withCredentials: false })
          .then(({ data }) => {
            this.location = {
              latitude: data.Latitude,
              longitude: data.Longitude
            }
          })
          .catch(error => {
            console.log(error)
          })
    },
  }
}
</script>
